<template>
    <div class="nav-sidebar-sport">
        <div class="nav-sidebar-terminal__wrapper nav-sidebar__wrapper--search">
            <SearchInput
                @submit="onSearchSubmit"
                :suggestionsFunction="searchFunction"
                :predefinedSuggestions="previousQueries"
            />
        </div>
        <div
            v-if="featuredItems.length > 0"
            class="nav-sidebar__wrapper"
        >
            <SidebarPromoItems
                :items="featuredItems"
                :selectedItemId="null"
                @click="setSelectedFeaturedItem"
            />
        </div>
        <div class="nav-sidebar__wrapper">
            <div class="nav-sidebar-superbets">
                <router-link
                    :to="routes.specials"
                    tag="div"
                    class="nav-sidebar-superbets__item--terminal nav-sidebar-superbets__item--special"
                    activeClass="is-active"
                >
                    <i class="icon icon-special"/>
                    <span>{{ $t('specials') }}</span>
                </router-link>
            </div>
        </div>
        <div class="nav-sidebar__wrapper">
            <div class="nav-sidebar-tree">
                <li class="nav-sidebar-tree__item-wrapper--terminal">
                    <router-link
                        :to="routes.allOfferRoute"
                        tag="div"
                        class="nav-sidebar-tree__item"
                    >
                        <i class="icon--md icon-chevron_left nav-sidebar-tree__icon"/>
                        {{ $t('back to offer') | upperCase }}
                    </router-link>
                </li>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import { links, routeNames } from 'src/app/router';
    import SearchInput from '@src/terminal/app/modules/sportOffer/sharedSubmodules/SearchInput.vue';
    import { allTimeFilterSlug } from '@store/modules/ui/shared/timeFilter/utils';
    import SidebarPromoItems from '@modules/shared/sidebar/SidebarPromoItems.vue';

    export default {
        name: 'SpecialsSidebar',
        created() {
            this.routes = {
                specials: { name: routeNames.special, params: { timeFilter: allTimeFilterSlug } },
                allOfferRoute: { name: routeNames.landing },
            };
        },
        computed: {
            ...mapGetters('ui/sportOffer/search', [
                'previousQueries',
                'suggestions',
            ]),
            ...mapGetters('data/sportOffer', [
                'featuredItems',
            ]),
        },
        methods: {
            ...mapActions('ui/sportOffer/sports', [
                'setSelectedFeaturedItem',
            ]),
            ...mapActions('ui/sportOffer/search', [
                'saveQuery',
            ]),
            onSearchSubmit(query) {
                this.saveQuery(query);
                this.$router.push({
                    path: links.search,
                    query: {
                        query,
                    },
                });
            },
            searchFunction(query) {
                return this.suggestions(query);
            },
        },
        components: {
            SidebarPromoItems,
            SearchInput,
        },
    };
</script>



// WEBPACK FOOTER //
// src/terminal/app/modules/specialOffer/sidebar/SpecialsSidebar.vue